﻿import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../resources/ResourcesStore";
import { LanguageSelectorItemComponent } from "./LanguageSelectorItem";
import { injectFromApp } from "../../inject";
import { RichToolTipComponent } from "../../rich-tooltip/RichToolTipComponent";

interface ILanguageSelectorComponentProps {
    resourcesStore?: IResourcesStore;
}

@injectFromApp<ILanguageSelectorComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class LanguageSelectorComponent extends React.Component<ILanguageSelectorComponentProps> {
    render() {
        const { resourcesStore } = this.props;
        const { possibleLanguages, currentLanguage } = resourcesStore!;

        return (
            <div id={ "language-selector" }>
                <RichToolTipComponent toolTipPosition="left" toolTipContent={ resourcesStore?.getResourceWithKey("__" + currentLanguage.toLowerCase()) } id="current-language">
                    { currentLanguage.substring(0, 2).toUpperCase() }
                </RichToolTipComponent>
                <div id={ "possible-languages" }>
                    { possibleLanguages
                        .filter((s) => s !== currentLanguage)
                        .map((x) => (
                            <LanguageSelectorItemComponent language={ x } key={ x }/>
                        )) }
                </div>
            </div>
        );
    }
}
